import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  titulo: string;
  descricao?: string;
  /** Conteúdo alinhado à direita (ex.: botão "Novo cupom"). Em xs, vai pra baixo do título. */
  acoes?: ReactNode;
}

/**
 * Cabeçalho padrão das telas do backoffice — título grande + subtítulo cinza +
 * área opcional de ações à direita. Responsivo: em mobile, ações descem pra
 * uma linha abaixo do título.
 */
export function HeaderTela({ titulo, descricao, acoes }: Props): JSX.Element {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 2, sm: 0 }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      sx={{ mb: { xs: 3, md: 4 } }}
    >
      <Box>
        <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.5rem', md: '2.125rem' }, mb: descricao ? 0.5 : 0 }}>
          {titulo}
        </Typography>
        {descricao && (
          <Typography color="text.secondary" variant="body2">
            {descricao}
          </Typography>
        )}
      </Box>
      {acoes && <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>{acoes}</Box>}
    </Stack>
  );
}
